import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Input,
  useDisclosure,
  FormControl,
  FormLabel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Flex,
  Tooltip,
  Alert,
  AlertIcon,
  useToast,
  Spinner,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Select,
  StatGroup,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  IconButton,
  AlertTitle,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import { stockService } from "../../../../services/stockService";
import { MdDelete } from "react-icons/md";
import { InfoIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { getBusinessSlug } from "../../../../utils/slugify";

// Gıda muhafaza bilgileri
const foodStorageInfo = {
  meyve_sebze: [
    {
      kategori: "Yeşil Yapraklı Sebzeler",
      urunler: "Marul, Ispanak, Roka, Semizotu, Maydanoz, Dereotu",
      tazelikSuresi: "3-5 gün",
      muhafaza: "4-7°C, yüksek nem, hava alan poşette",
      ipucu: "Yaprakları yıkamadan, hafif nemli şekilde saklayın"
    },
    {
      kategori: "Kök Sebzeler",
      urunler: "Havuç, Patates, Soğan, Sarımsak, Turp, Şalgam",
      tazelikSuresi: "14-20 gün",
      muhafaza: "10-15°C, karanlık ve serin ortam",
      ipucu: "Patates ve soğanı ayrı saklayın, birbirini etkiler"
    },
    {
      kategori: "Yumuşak Meyveler",
      urunler: "Çilek, Ahududu, Üzüm, Kiraz, Dut, İncir",
      tazelikSuresi: "3-5 gün",
      muhafaza: "4°C, nemli ortam, yıkanmadan",
      ipucu: "Kullanmadan hemen önce yıkayın"
    },
    {
      kategori: "Sert Meyveler",
      urunler: "Elma, Armut, Ayva, Nar",
      tazelikSuresi: "14-20 gün",
      muhafaza: "4-7°C, nem kontrollü ortam",
      ipucu: "Diğer meyvelerden ayrı saklayın, etilen gazı salgılar"
    },
    {
      kategori: "Narenciye",
      urunler: "Portakal, Mandalina, Limon, Greyfurt",
      tazelikSuresi: "10-14 gün",
      muhafaza: "8-12°C, orta nem",
      ipucu: "Oda sıcaklığında 1 hafta dayanır"
    },
    {
      kategori: "Kabakgiller",
      urunler: "Salatalık, Kabak, Kavun, Karpuz",
      tazelikSuresi: "7-10 gün",
      muhafaza: "8-12°C, orta nem",
      ipucu: "Kesildikten sonra hemen tüketin"
    }
  ],
  et_süt: [
    {
      kategori: "Kırmızı Et",
      tazelikSuresi: "3-5 gün",
      muhafaza: "0-4°C, vakumlu paket",
      ipucu: "Dondurucuda -18°C'de 6 ay saklanabilir"
    },
    {
      kategori: "Tavuk",
      tazelikSuresi: "1-2 gün",
      muhafaza: "0-4°C, orijinal ambalajında",
      ipucu: "Çözdürüldükten sonra tekrar dondurmayın"
    },
    {
      kategori: "Balık",
      tazelikSuresi: "1-2 gün",
      muhafaza: "0-2°C, buz üzerinde",
      ipucu: "Taze balık parlak görünümlü olmalı"
    },
    {
      kategori: "Süt",
      tazelikSuresi: "5-7 gün",
      muhafaza: "4°C, kapalı ambalajında",
      ipucu: "Kapağını açtıktan sonra 3-4 gün içinde tüketin"
    },
    {
      kategori: "Peynir",
      tazelikSuresi: "7-14 gün",
      muhafaza: "4°C, hava almayan kapta",
      ipucu: "Küflenen kısımları tamamen atın"
    },
    {
      kategori: "Yoğurt",
      tazelikSuresi: "7-10 gün",
      muhafaza: "4°C, orijinal kabında",
      ipucu: "Metal kaşık kullanmayın"
    }
  ],
  kuru_gida: [
    {
      kategori: "Bakliyat",
      urunler: "Nohut, Mercimek, Fasulye, Barbunya",
      tazelikSuresi: "6-12 ay",
      muhafaza: "Serin, kuru ortam, hava almayan kapta",
      ipucu: "Cam kavanozda saklamak ideal"
    },
    {
      kategori: "Tahıllar",
      urunler: "Pirinç, Bulgur, Kinoa",
      tazelikSuresi: "6-8 ay",
      muhafaza: "Serin, kuru ortam, hava almayan kapta",
      ipucu: "Böceklenmeye karşı defne yaprağı ekleyin"
    },
    {
      kategori: "Un ve Unlu Mamuller",
      urunler: "Buğday Unu, Mısır Unu, Nişasta",
      tazelikSuresi: "4-6 ay",
      muhafaza: "Serin, kuru ortam, hava almayan kapta",
      ipucu: "Uzun süre saklamak için buzdolabı kullanın"
    },
    {
      kategori: "Kuruyemişler",
      urunler: "Fındık, Ceviz, Badem, Antep Fıstığı",
      tazelikSuresi: "3-6 ay",
      muhafaza: "Serin, kuru ortam, hava almayan kapta",
      ipucu: "Acılaşmaması için buzdolabında saklayın"
    }
  ],
  baharat_sos: [
    {
      kategori: "Taze Otlar",
      urunler: "Fesleğen, Kekik, Biberiye, Nane",
      tazelikSuresi: "5-7 gün",
      muhafaza: "Su dolu kapta, buzdolabında",
      ipucu: "Sapları keserek suyu düzenli değiştirin"
    },
    {
      kategori: "Kuru Baharatlar",
      urunler: "Karabiber, Pul Biber, Kimyon",
      tazelikSuresi: "6-12 ay",
      muhafaza: "Kuru, karanlık ortam, hava almayan kapta",
      ipucu: "Güneş ışığından uzak tutun"
    },
    {
      kategori: "Soslar",
      urunler: "Ketçap, Mayonez, Hardal",
      tazelikSuresi: "6-8 ay",
      muhafaza: "Buzdolabında, kapalı şekilde",
      ipucu: "Açıldıktan sonra 1-2 ay içinde tüketin"
    }
  ]
};

const Stocks = () => {
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newProduct, setNewProduct] = useState({
    productName: "",
    stockQuantity: 0,
    minThreshold: 0,
    freshnessDays: 0,
    category: "",
    unit: "kg",
    supplier: {
      name: "",
      contactPerson: "",
      phone: "",
      email: "",
      orderThreshold: 0,
      minimumOrderQuantity: 0
    }
  });
  const [filterStatus, setFilterStatus] = useState('all');
  const [sortBy, setSortBy] = useState('name');

  const toast = useToast();
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isInfoOpen, onOpen: onInfoOpen, onClose: onInfoClose } = useDisclosure();

  const handleNavigateToSuppliers = () => {
    const businessSlug = getBusinessSlug();
    if (businessSlug) {
      navigate(`/admin/${businessSlug}/tedarikciler`);
    } else {
      navigate('/admin/tedarikciler');
    }
  };

  // Stokları getir
  const fetchStocks = async () => {
    try {
      setLoading(true);
      const response = await stockService.getStocks();
      if (response.success) {
        setStocks(response.stocks);
      }
    } catch (error) {
      toast({
        title: "Hata",
        description: "Stoklar yüklenirken bir hata oluştu",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStocks();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProduct({ ...newProduct, [name]: value });
  };

  // Yeni ürün ekle
  const handleAddProduct = async () => {
    try {
      const { productName, stockQuantity, minThreshold, freshnessDays, category, unit } = newProduct;
      
      if (!productName || !stockQuantity || !minThreshold || !freshnessDays || !category) {
        toast({
          title: "Hata",
          description: "Lütfen tüm alanları doldurun",
          status: "error",
          duration: 2000,
        });
        return;
      }

      const stockData = {
        productName,
        stockQuantity: Number(stockQuantity),
        minThreshold: Number(minThreshold),
        freshnessDays: Number(freshnessDays),
        category,
        unit
      };

      const response = await stockService.createStock(stockData);

      if (response.success) {
        await fetchStocks();
        onClose();
        setNewProduct({
          productName: "",
          stockQuantity: 0,
          minThreshold: 0,
          freshnessDays: 0,
          category: "",
          unit: "kg"
        });
        toast({
          title: "Başarılı",
          description: "Ürün başarıyla eklendi",
          status: "success",
          duration: 2000,
        });
      }
    } catch (error) {
      toast({
        title: "Hata",
        description: "Ürün eklenirken bir hata oluştu",
        status: "error",
        duration: 3000,
      });
    }
  };

  // Ürün sil
  const handleRemoveProduct = async (stockId) => {
    try {
      const response = await stockService.deleteStock(stockId);
      if (response.success) {
        await fetchStocks();
        toast({
          title: "Başarılı",
          description: "Ürün başarıyla silindi",
          status: "success",
          duration: 2000,
        });
      }
    } catch (error) {
      toast({
        title: "Hata",
        description: "Ürün silinirken bir hata oluştu",
        status: "error",
        duration: 3000,
      });
    }
  };

  // Stok miktarını güncelle
  const handleUpdateStock = async (stockId, newQuantity) => {
    try {
      const response = await stockService.updateStock(stockId, {
        stockQuantity: Number(newQuantity)
      });
      if (response.success) {
        await fetchStocks();
        toast({
          title: "Başarılı",
          description: "Stok miktarı güncellendi",
          status: "success",
          duration: 2000,
        });
      }
    } catch (error) {
      toast({
        title: "Hata",
        description: "Stok güncellenirken bir hata oluştu",
        status: "error",
        duration: 3000,
      });
    }
  };

  // Tazelik durumunu hesapla
  const calculateFreshness = (addedDate, freshnessDays) => {
    const today = new Date();
    const added = new Date(addedDate);
    const daysPassed = Math.floor((today - added) / (1000 * 60 * 60 * 24));
    const daysLeft = freshnessDays - daysPassed;

    if (daysLeft <= 0) {
      return { status: "Süresi Dolmuş", color: "red.500" };
    } else if (daysLeft <= 5) {
      return { status: "Son Kullanım Yakın!", color: "orange.500" };
    }
    return { status: "Taze", color: "green.500" };
  };

  // Stok durumunu hesapla
  const calculateStockStatus = (quantity, threshold) => {
    if (quantity <= 0) {
      return { status: "Ürün kalmadı", color: "red.500" };
    } else if (quantity <= threshold * 0.5) {
      return { status: "Bitmek Üzere!", color: "red.500" };
    } else if (quantity <= threshold) {
      return { status: "Sınıra Yakın", color: "orange.500" };
    }
    return { status: "Yeterli", color: "green.500" };
  };

  // Filtrelenmiş stokları getir
  const getFilteredStocks = () => {
    let filtered = [...stocks];

    // Durum filtreleme
    if (filterStatus === 'low') {
      filtered = filtered.filter(stock => stock.stockQuantity <= stock.minThreshold);
    } else if (filterStatus === 'expired') {
      filtered = filtered.filter(stock => {
        const freshness = calculateFreshness(stock.addedDate, stock.freshnessDays);
        return freshness.status === "Süresi Dolmuş" || freshness.status === "Son Kullanım Yakın!";
      });
    } else if (filterStatus === 'fresh') {
      filtered = filtered.filter(stock => {
        const freshness = calculateFreshness(stock.addedDate, stock.freshnessDays);
        return freshness.status === "Taze";
      });
    }

    // Sıralama
    filtered.sort((a, b) => {
      if (sortBy === 'name') {
        return a.productName.localeCompare(b.productName);
      } else if (sortBy === 'quantity') {
        return b.stockQuantity - a.stockQuantity;
      } else if (sortBy === 'date') {
        return new Date(b.addedDate) - new Date(a.addedDate);
      }
      return 0;
    });

    return filtered;
  };

  return (
    <Box p={4}>
      {/* Başlık ve Slogan */}
      <Flex direction="column" mb={6}>
        <Flex justify="space-between" align="center" mb={2}>
          <Text 
            fontSize="2xl" 
            fontWeight="bold"
            mr={8}
          >
            Stok Yönetim Paneli
          </Text>
          <Tooltip 
            label="Gıda Muhafaza Bilgileri" 
            hasArrow
            placement="top"
          >
            <Button
              leftIcon={<InfoIcon />}
              size="sm"
              colorScheme="blue"
              variant="outline"
              onClick={onInfoOpen}
              _hover={{
                bg: 'blue.50',
                transform: 'scale(1.05)'
              }}
              transition="all 0.2s"
            >
              Tazelik Rehberi
            </Button>
          </Tooltip>
        </Flex>
        <Flex align="center" gap={2}>
          <Text 
            fontSize="md" 
            fontStyle="italic" 
            color="gray.600"
            borderLeft="4px solid"
            borderColor="blue.400"
            pl={2}
            _hover={{
              color: "blue.600",
              transition: "all 0.3s ease"
            }}
          >
            "Müşterilerinize her zaman taze gıdalar sunalım!"
          </Text>
          <Text 
            as="span" 
            color="green.500" 
            fontSize="lg"
          >
            🌱
          </Text>
        </Flex>
      </Flex>

      {/* Stok İstatistikleri */}
      <StatGroup mb={6}>
        <Stat>
          <StatLabel>Toplam Ürün</StatLabel>
          <StatNumber>{stocks.length}</StatNumber>
        </Stat>
        <Stat>
          <StatLabel>Kritik Stoklar</StatLabel>
          <StatNumber color="red.500">
            {stocks.filter(s => s.stockQuantity <= s.minThreshold).length}
          </StatNumber>
        </Stat>
        <Stat>
          <StatLabel>Tazelik Süresi Yakın</StatLabel>
          <StatNumber color="orange.500">
            {stocks.filter(s => {
              const freshness = calculateFreshness(s.addedDate, s.freshnessDays);
              return freshness.status === "Son Kullanım Yakın!";
            }).length}
          </StatNumber>
        </Stat>
        <Stat>
          <StatLabel>Son Güncelleme</StatLabel>
          <StatHelpText>
            <Flex align="center" gap={2}>
              {new Date().toLocaleDateString()}
            </Flex>
          </StatHelpText>
        </Stat>
      </StatGroup>

      {/* Filtreler ve Yeni Ürün Butonu */}
      <Flex 
        mb={4} 
        justify="space-between" 
        align="center"
        flexDirection={{ base: "column", md: "row" }}
        gap={{ base: 3, md: 0 }}
      >
        <Flex 
          gap={{ base: 2, md: 4 }}
          flexDirection={{ base: "column", sm: "row" }}
          w={{ base: "100%", md: "auto" }}
        >
          <Select 
            size={{ base: "sm", md: "sm" }} 
            w={{ base: "100%", sm: "200px" }}
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
          >
            <option value="all">Tüm Stoklar</option>
            <option value="low">Kritik Stoklar</option>
            <option value="expired">Süresi Yaklaşanlar</option>
            <option value="fresh">Taze Ürünler</option>
          </Select>

          <Select
            size={{ base: "sm", md: "sm" }}
            w={{ base: "100%", sm: "200px" }}
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
          >
            <option value="name">İsme Göre</option>
            <option value="quantity">Miktara Göre</option>
            <option value="date">Tarihe Göre</option>
          </Select>
        </Flex>

        <Button 
          bg="#E45858" 
          color="white" 
          onClick={onOpen}
          size={{ base: "sm", md: "md" }}
          w={{ base: "100%", md: "auto" }}
        >
          Yeni Ürün Ekle
        </Button>
      </Flex>

      {/* Uyarılar */}
      <Box mb={4}>
        {stocks.some(item => item.stockQuantity <= 0) && (
          <Alert status="error" mb={2}>
            <AlertIcon />
            <Box>
              <AlertTitle>Biten Ürünler!</AlertTitle>
              <Text fontSize="sm">
                {stocks
                  .filter(item => item.stockQuantity <= 0)
                  .map(item => item.productName)
                  .join(', ')} stokları tükenmiştir.
              </Text>
            </Box>
          </Alert>
        )}

        {stocks.some(item => item.stockQuantity > 0 && item.stockQuantity <= item.minThreshold) && (
          <Alert status="warning" mb={2}>
            <AlertIcon />
            <Box>
              <AlertTitle>Kritik Stok Uyarısı!</AlertTitle>
              <Text fontSize="sm">
                {stocks
                  .filter(item => item.stockQuantity > 0 && item.stockQuantity <= item.minThreshold)
                  .map(item => `${item.productName} (${item.stockQuantity} ${item.unit})`)
                  .join(', ')} ürünleri kritik seviyededir.
              </Text>
            </Box>
          </Alert>
        )}
      </Box>

      {/* Yeni Ürün Modalı */}
      <Modal isOpen={isOpen} onClose={onClose} size={{ base: "full", sm: "xl" }}>
        <ModalOverlay backdropFilter="blur(4px)" />
        <ModalContent mx={{ base: 0, sm: "auto" }} maxW={{ base: "100%", sm: "600px" }}>
          <ModalHeader fontSize={{ base: "lg", md: "xl" }}>Yeni Ürün Ekle</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4} isRequired>
              <FormLabel fontSize={{ base: "sm", md: "md" }}>Ürün Adı</FormLabel>
              <Input
                name="productName"
                value={newProduct.productName}
                onChange={handleInputChange}
                placeholder="Ürün adını girin"
                size={{ base: "sm", md: "md" }}
              />
            </FormControl>

            <FormControl mb={4} isRequired>
              <FormLabel fontSize={{ base: "sm", md: "md" }}>Kategori</FormLabel>
              <Select
                name="category"
                value={newProduct.category}
                onChange={handleInputChange}
                placeholder="Kategori seçin"
                size={{ base: "sm", md: "md" }}
              >
                <option value="Gıda">Gıda</option>
                <option value="İçecek">İçecek</option>
                <option value="Temizlik">Temizlik</option>
                <option value="Diğer">Diğer</option>
              </Select>
            </FormControl>

            <FormControl mb={4} isRequired>
              <FormLabel fontSize={{ base: "sm", md: "md" }}>Birim</FormLabel>
              <Select
                name="unit"
                value={newProduct.unit}
                onChange={handleInputChange}
                size={{ base: "sm", md: "md" }}
              >
                <option value="kg">Kilogram (kg)</option>
                <option value="lt">Litre (lt)</option>
                <option value="adet">Adet</option>
                <option value="paket">Paket</option>
              </Select>
            </FormControl>

            <FormControl mb={4} isRequired>
              <FormLabel fontSize={{ base: "sm", md: "md" }}>Stok Miktarı</FormLabel>
              <NumberInput
                name="stockQuantity"
                value={newProduct.stockQuantity}
                min={0}
                size={{ base: "sm", md: "md" }}
                onChange={(value) => handleInputChange({
                  target: { name: "stockQuantity", value }
                })}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>

            <FormControl mb={4} isRequired>
              <FormLabel fontSize={{ base: "sm", md: "md" }}>Minimum Stok Eşiği</FormLabel>
              <NumberInput
                name="minThreshold"
                value={newProduct.minThreshold}
                min={0}
                size={{ base: "sm", md: "md" }}
                onChange={(value) => handleInputChange({
                  target: { name: "minThreshold", value }
                })}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontSize={{ base: "sm", md: "md" }}>Tazelik Süresi (gün)</FormLabel>
              <NumberInput
                name="freshnessDays"
                value={newProduct.freshnessDays}
                min={1}
                size={{ base: "sm", md: "md" }}
                onChange={(value) => handleInputChange({
                  target: { name: "freshnessDays", value }
                })}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>
          </ModalBody>
          <ModalFooter flexDirection={{ base: "column", sm: "row" }} gap={{ base: 2, sm: 0 }}>
            <Button 
              colorScheme="red" 
              mr={{ base: 0, sm: 3 }} 
              onClick={handleAddProduct}
              size={{ base: "sm", md: "md" }}
              w={{ base: "100%", sm: "auto" }}
            >
              Ekle
            </Button>
            <Button 
              onClick={onClose}
              size={{ base: "sm", md: "md" }}
              w={{ base: "100%", sm: "auto" }}
            >
              İptal
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {loading ? (
        <Flex justify="center" align="center" h="200px">
          <Spinner size="xl" color="red.500" />
        </Flex>
      ) : (
        <Box overflowX="auto">
          <Table variant="simple" minW={{ base: "900px", md: "auto" }}>
            <Thead>
              <Tr>
                <Th fontSize={{ base: "xs", md: "sm" }} px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>Ürün Adı</Th>
                <Th fontSize={{ base: "xs", md: "sm" }} px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>Stok Miktarı</Th>
                <Th fontSize={{ base: "xs", md: "sm" }} px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>Eklenme Tarihi</Th>
                <Th fontSize={{ base: "xs", md: "sm" }} px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>Tazelik Durumu</Th>
                <Th fontSize={{ base: "xs", md: "sm" }} px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>Stok Durumu</Th>
                <Th fontSize={{ base: "xs", md: "sm" }} px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>İşlemler</Th>
              </Tr>
            </Thead>
            <Tbody>
              {getFilteredStocks().map((item) => {
                const freshness = calculateFreshness(item.addedDate, item.freshnessDays);
                const stockStatus = calculateStockStatus(item.stockQuantity, item.minThreshold);

                return (
                  <Tr key={item._id}>
                    <Td px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>
                      <Flex align="center" gap={2} flexWrap="wrap">
                        <Text fontSize={{ base: "xs", md: "sm" }}>{item.productName}</Text>
                        <Tooltip
                          hasArrow
                          label={
                            <Box p={2}>
                              <Text><strong>Minimum Stok Eşiği:</strong> {item.minThreshold} {item.unit}</Text>
                              <Text><strong>Tazelik Süresi:</strong> {item.freshnessDays} gün</Text>
                              <Text><strong>Kategori:</strong> {item.category}</Text>
                              {item.maxThreshold && (
                                <Text><strong>Maksimum Stok:</strong> {item.maxThreshold} {item.unit}</Text>
                              )}
                              {item.notes && (
                                <Text><strong>Notlar:</strong> {item.notes}</Text>
                              )}
                            </Box>
                          }
                          bg="gray.700"
                          color="white"
                          placement="right"
                        >
                          <Text 
                            fontSize={{ base: "xs", md: "sm" }} 
                            color="gray.500" 
                            cursor="help"
                            _hover={{ color: "gray.700" }}
                          >
                            ❓
                          </Text>
                        </Tooltip>
                      </Flex>
                    </Td>
                    <Td px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>
                      <Flex align="center" gap={2} flexWrap="wrap">
                        <NumberInput
                          size={{ base: "xs", md: "sm" }}
                          maxW={{ base: 20, md: 24 }}
                          value={item.stockQuantity}
                          min={0}
                          precision={2}
                          step={0.5}
                          onChange={(value) => handleUpdateStock(item._id, value)}
                        >
                          <NumberInputField fontSize={{ base: "xs", md: "sm" }} />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                        <Text fontSize={{ base: "xs", md: "sm" }}>{item.unit}</Text>
                      </Flex>
                    </Td>
                    <Td fontSize={{ base: "xs", md: "sm" }} px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }} whiteSpace="nowrap">
                      {new Date(item.addedDate).toLocaleDateString()}
                    </Td>
                    <Td px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>
                      <Text fontSize={{ base: "xs", md: "sm" }} color={freshness.color}>{freshness.status}</Text>
                    </Td>
                    <Td px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>
                      <Text fontSize={{ base: "xs", md: "sm" }} color={stockStatus.color}>{stockStatus.status}</Text>
                    </Td>
                    <Td px={{ base: 2, md: 4 }} py={{ base: 2, md: 3 }}>
                      <Flex gap={2} flexWrap="wrap">
                        <IconButton
                          aria-label="Sil"
                          icon={<MdDelete />}
                          variant="outline"
                          colorScheme="red"
                          size={{ base: "xs", md: "sm" }}
                          onClick={() => handleRemoveProduct(item._id)}
                        />
                        {(stockStatus.status === "Ürün kalmadı" ||
                          stockStatus.status.includes("Bitmek Üzere!")) && (
                          <Button
                            colorScheme="red"
                            size={{ base: "xs", md: "sm" }}
                            fontSize={{ base: "xs", md: "sm" }}
                            onClick={handleNavigateToSuppliers}
                          >
                            Tedarik Et
                          </Button>
                        )}
                        {stockStatus.status.includes("Sınıra") && (
                          <Button
                            colorScheme="orange"
                            variant="outline"
                            size={{ base: "xs", md: "sm" }}
                            fontSize={{ base: "xs", md: "sm" }}
                            onClick={handleNavigateToSuppliers}
                          >
                            Tedarik Et
                          </Button>
                        )}
                      </Flex>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </Box>
      )}

      {/* Gıda Muhafaza Bilgileri Modalı */}
      <Modal isOpen={isInfoOpen} onClose={onInfoClose} size="xl">
        <ModalOverlay backdropFilter="blur(4px)" />
        <ModalContent maxWidth="900px">
          <ModalHeader bg="blue.50" borderTopRadius="md">
            <Flex align="center" gap={2}>
              <InfoIcon />
              <Text>Gıda Muhafaza Rehberi</Text>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody py={6}>
            <Accordion allowMultiple>
              {Object.entries(foodStorageInfo).map(([category, items]) => (
                <AccordionItem key={category}>
                  <AccordionButton _expanded={{ bg: 'blue.50' }}>
                    <Box flex="1" textAlign="left" fontWeight="bold">
                      {category === 'meyve_sebze' && 'Meyve ve Sebzeler'}
                      {category === 'et_süt' && 'Et ve Süt Ürünleri'}
                      {category === 'kuru_gida' && 'Kuru Gıdalar'}
                      {category === 'baharat_sos' && 'Baharatlar ve Soslar'}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel pb={4}>
                    {items.map((item, index) => (
                      <Box 
                        key={index} 
                        mb={4} 
                        p={4} 
                        borderWidth="1px" 
                        borderRadius="md"
                        borderColor="blue.200"
                        bg="blue.50"
                        _hover={{ bg: 'blue.100' }}
                      >
                        <Text fontSize="lg" fontWeight="bold" color="blue.700" mb={2}>
                          {item.kategori}
                        </Text>
                        {item.urunler && (
                          <Text mb={1}><strong>Ürünler:</strong> {item.urunler}</Text>
                        )}
                        <Text mb={1}><strong>Tazelik Süresi:</strong> {item.tazelikSuresi}</Text>
                        <Text mb={1}><strong>Muhafaza:</strong> {item.muhafaza}</Text>
                        <Text color="orange.600">
                          <strong>İpucu:</strong> {item.ipucu}
                        </Text>
                      </Box>
                    ))}
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>

            <Alert 
              status="info" 
              mt={6}
              variant="left-accent"
              borderRadius="md"
            >
              <AlertIcon />
              <Box>
                <AlertTitle mb={2}>Önemli Hatırlatmalar:</AlertTitle>
                <UnorderedList spacing={2}>
                  <ListItem>Tüm ürünleri düzenli olarak kontrol edin</ListItem>
                  <ListItem>Buzdolabı sıcaklığını günlük olarak takip edin (4°C)</ListItem>
                  <ListItem>FIFO (İlk Giren İlk Çıkar) prensibini uygulayın</ListItem>
                  <ListItem>Çiğ ve pişmiş ürünleri ayrı saklayın</ListItem>
                  <ListItem>Açılan paketleri hava almayacak şekilde kapatın</ListItem>
                  <ListItem>Dondurulmuş ürünleri buzdolabında çözdürün</ListItem>
                </UnorderedList>
              </Box>
            </Alert>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Stocks;
